import React from "react";
import { TIMELINE } from "../data";

export default function Timeline() {
  return (
    <section id="history">
      <div className="section-head">
        <div className="label">§03 · experience</div>
        <div className="h">Professional Experience</div>
        <div className="meta"></div>
      </div>

      <div className="timeline">
        {TIMELINE.map((e) => (
          <div className={"commit" + (e.now ? " now" : "")} key={e.hash}>
            <div className="when">
              <b>{e.when.y}</b>
              {e.when.m}
            </div>
            <div className="glyph" />
            <div>
              <div className="hashref">
                <span className="hash">{e.hash}</span>
                <span className="branch">
                  {e.branch}
                  {e.now ? " · HEAD" : ""}
                </span>
              </div>
              <div className="role-title">
                {e.title} · <span className="org">{e.org}</span>
              </div>
              <ul>
                {e.bullets.map((b) => <li key={b}>{b}</li>)}
              </ul>
              <div className="refs">
                {e.refs.map((r) => (
                  <span className="tag-sm" key={r}>{r}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
